/**
 * @generated SignedSource<<1336de8f07891a19bf246201a984fa05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectRootNodesTable_QueryFragment$data = {
  readonly Admin: {
    readonly Tree: {
      readonly GetRootNodes: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"RootNodesTable_TreeNodeFragment">;
          };
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
          readonly hasPreviousPage: boolean;
          readonly startCursor: string | null | undefined;
        };
      };
    };
  };
  readonly " $fragmentType": "ProjectRootNodesTable_QueryFragment";
};
export type ProjectRootNodesTable_QueryFragment$key = {
  readonly " $data"?: ProjectRootNodesTable_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectRootNodesTable_QueryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "Admin",
  "Tree",
  "GetRootNodes"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dateTime",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByInternalVnr"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByIsRewardedByAny"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByTagIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByTitleOrDescriptionOrShortDescription"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByVisibility"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterByVnr"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./ProjectRootNodesTable_Refetch.graphql')
    }
  },
  "name": "ProjectRootNodesTable_QueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TreeAdminSchema",
          "kind": "LinkedField",
          "name": "Tree",
          "plural": false,
          "selections": [
            {
              "alias": "GetRootNodes",
              "args": [
                {
                  "kind": "Variable",
                  "name": "filterByInternalVnr",
                  "variableName": "filterByInternalVnr"
                },
                {
                  "kind": "Variable",
                  "name": "filterByIsRewardedByAny",
                  "variableName": "filterByIsRewardedByAny"
                },
                {
                  "kind": "Variable",
                  "name": "filterByTagIds",
                  "variableName": "filterByTagIds"
                },
                {
                  "kind": "Variable",
                  "name": "filterByTitleOrDescriptionOrShortDescription",
                  "variableName": "filterByTitleOrDescriptionOrShortDescription"
                },
                {
                  "kind": "Variable",
                  "name": "filterByVisibility",
                  "variableName": "filterByVisibility"
                },
                {
                  "kind": "Variable",
                  "name": "filterByVnr",
                  "variableName": "filterByVnr"
                }
              ],
              "concreteType": "TreeNodesConnection",
              "kind": "LinkedField",
              "name": "__RootNodesTable_GetRootNodes_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasPreviousPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startCursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TreeNodesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TreeNode",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "RootNodesTable_TreeNodeFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "structureDefinition",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": null,
                                      "kind": "LinkedField",
                                      "name": "extension",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "TreeConfigConsequences",
                                              "kind": "LinkedField",
                                              "name": "configConsequences",
                                              "plural": false,
                                              "selections": [
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "kind": "ScalarField",
                                                  "name": "rewardExpired",
                                                  "storageKey": null
                                                }
                                              ],
                                              "storageKey": null
                                            }
                                          ],
                                          "type": "RootExtensionImpl",
                                          "abstractKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": null,
                                      "kind": "LinkedField",
                                      "name": "visibilityConfigs",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "configType",
                                          "storageKey": null
                                        },
                                        {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            {
                                              "alias": null,
                                              "args": null,
                                              "kind": "ScalarField",
                                              "name": "id",
                                              "storageKey": null
                                            },
                                            (v1/*: any*/)
                                          ],
                                          "type": "OnlySpecificPermissionsVisibilityTreeConfig",
                                          "abstractKey": null
                                        },
                                        {
                                          "kind": "InlineFragment",
                                          "selections": (v2/*: any*/),
                                          "type": "NotAfterDateTimeVisibilityTreeConfig",
                                          "abstractKey": null
                                        },
                                        {
                                          "kind": "InlineFragment",
                                          "selections": (v2/*: any*/),
                                          "type": "AfterDateTimeVisibilityTreeConfig",
                                          "abstractKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "type": "RootStructureDefinition",
                                  "abstractKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ActionColumn_TreeNodeFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ConfigurationBadgesColumn_TreeNodeFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ContentColumn_TreeNodeFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "IsRewardedToColumn_TreeNodeFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "ReleasedAtColumn_TreeNodeFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "TagsColumn_TreeNodeFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "TitleColumn_TreeNodeFragment"
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__id",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "59965db4b79d7143e7cec645274606fd";

export default node;
